@app.directive 'flags', ($rootScope, $state, ShopifyService, LocationService, navService, csConfig ) ->
  restrict: 'E'
  scope: {}
  controllerAs: 'flag'
  controller: ($scope) ->

    @showFlag = false
    @isLowStock = false
    @product = ShopifyService.variantForSku 'cs10001'
    @isInUS = ->
      LocationService.isInUS()

    if @product && @isInUS()
      # Show flag if any inventory is present
      if @product.inventory_quantity > 0
        @showFlag = true
        $rootScope.$emit 'flag.stateChange'
        # Show low inventory flag below 500 units
        if @product.inventory_quantity <= 500
          @isLowStock = true

      # Hide flag on 0 inventory
      if @product.inventory_quantity <= 0
        @showFlag = false

    else if !@product
      Rollbar.error("Flag - @product not set for flags at url: #{$state.current.url}")

    @closeFlag = ->
      @showFlag = false
      $rootScope.$emit 'flag.stateChange'

    this

  templateUrl: "/assets/templates/directives/flags/flags.html"
